import type { FC, HTMLAttributes } from 'react';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import type { DensityType } from '../../../utils/density';
import type { CommonDensityMenuProps } from '../DensityMenu';
import { DensityItem, densityMessages } from './DensityItem';

type DensityMenuDesktopProps = HTMLAttributes<HTMLDivElement> & CommonDensityMenuProps;

const DensityMenuDesktop: FC<DensityMenuDesktopProps> = memo(function DensityMenuDesktop(props) {
  const {
    options,
    currentDensity,
    isCurrentDensity,
    onDensityChange,
    itemsClass,
    className,
    ...otherProps
  } = props;

  return (
    <div className={twMerge('DensityMenuDesktop', className)} {...otherProps}>
      {Object.keys(densityMessages).map(type => (
        <DensityItem
          key={type}
          densityType={type as DensityType}
          isActive={isCurrentDensity(type as DensityType)}
          className={itemsClass}
          onClick={() => onDensityChange(type as DensityType)}
          withTooltip
        />
      ))}
    </div>
  );
});

export default DensityMenuDesktop;
